import ModalComponent from '@components/common/Modal';
import { Form, Input, message } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
import Helpers from 'helpers/Helpers';

interface IOMConfig {
  isOpen: boolean;
  base64?: string;
  callBackClose?: () => any;
  callBackRefresh?: () => any;
  callBackCreate?: (data: any) => any;
  listHinhNew?: any;
  data?: any;
  status?: any;
  listHinh?: any;
  images1?: any;
  //   dataAccountant: ISelectOption[];
}
export default function ModalViewImages(props: IOMConfig) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const value = [];
  const imageRef = useRef<any>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [rotation, setRotation] = React.useState(0);

  const rotateClockwise = useCallback(() => {
    setRotation(rotation => {
      const newRotation = (rotation + 90) % 360;
      return newRotation;
    });
  }, [setRotation]);

  const rotateAnticlockwise = useCallback(() => {
    setRotation(rotation => {
      const newRotation = (rotation - 90) % 360;
      return newRotation;
    });
  }, [setRotation]);

  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
      <div className="relative space-x-1 m-2 flex justify-center items-center">
        <button
          className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold px-2 hover:text-white border border-blue-500 hover:border-transparent rounded"
          onClick={() => zoomIn()}
        >
          Zoom In
        </button>
        <button
          className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold px-2 hover:text-white border border-blue-500 hover:border-transparent rounded"
          onClick={() => zoomOut()}
        >
          Zoom Out
        </button>
        <button
          className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold px-2 hover:text-white border border-blue-500 hover:border-transparent rounded"
          onClick={() => resetTransform()}
        >
          Reset
        </button>
        <button
          className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold px-2 hover:text-white border border-blue-500 hover:border-transparent rounded"
          onClick={() => rotateAnticlockwise()}
        >
          Rotate Left
        </button>
        <button
          className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold px-2 hover:text-white border border-blue-500 hover:border-transparent rounded"
          onClick={() => rotateClockwise()}
        >
          Rotate Right
        </button>
      </div>
    );
  };

  // khởi tạo luôn để dành khi tải thì dùng
  useEffect(() => {
    imageRef.current = new Image();
    imageRef.current.src = `${props.base64 || props.images1.url}?crossorigin`; // thêm vào để src tránh bắt cors server
    imageRef.current.setAttribute('crossOrigin', 'anonymous'); // sử dụng tránh cors

    // cần xử lý lại k được để các xử lý dạng này ngoài hook useEffect | useMemo
    // props.listHinh?.map(e => {
    //   if (e.url === props.base64) {
    //     return value.push(e);
    //   }
    //   return value;
    // });

    return () => {
      imageRef.current = null; // xoá sau khi rời trang
    };
  }, [props.isOpen]);

  const handleDownloadImage = async (id: string) => {
    try {
      setIsSaving(true);
      console.log('start save');
      // const downloadedImg: any = document.querySelector(`#${id}`); // lấy tag ảnh
      const canvas: any = document.getElementById('idcanvas');
      const ctx = canvas.getContext('2d');

      const widthImg = imageRef.current.width;
      const heightImg = imageRef.current.height;
      canvas.width = widthImg; // set kích thước ảnh canvas
      canvas.height = heightImg; // set kích thước ảnh canvas
      // console.log(
      //   'img info',
      //   // downloadedImg,
      //   // downloadedImg.width,
      //   // downloadedImg.height,
      //   imageRef.current,
      //   widthImg,
      //   heightImg
      // );
      await ctx.drawImage(imageRef.current, 0, 0, widthImg, heightImg, 0, 0, widthImg, heightImg);
      // draw ảnh vào canvas (img, sx (vị trí cắt trên ảnh gốc),  (vị trí cắt trên ảnh gốc), sWidth (kích thước sẽ lấy), sHeight (kích thước sẽ lấy), dx (vị trí đặt trên canvas), dy (vị trí đặt trên canvas), dWidth(kích thuốc ảnh trên canvas), dHeight(kích thuốc ảnh trên canvas) )

      const a = document.createElement('a');
      a.download = 'aom1_download_' + Helpers.ConvertDateToISOString(new Date()).slice(0, -1) + '.png';
      document.body.appendChild(a);
      a.href = canvas.toDataURL('image/png'); // convert canvas to url png
      a.click();
      document.body.removeChild(a);

      // chiều cao ảnh dạng px tương ứng với độ delay tắt loading status
      setTimeout(() => {
        console.log('done save');
        setIsSaving(false);
      }, heightImg);
    } catch (error) {
      console.log('err load img', error);
      message.error(t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ErrorSaveImg'));
      setIsSaving(false);
    }
  };

  return (
    <ModalComponent
      modalTitle={t('Administrator.UploadImage.Title')}
      modalSize="medium"
      visible={props.isOpen}
      hiddenFooter
      onCancel={props.callBackClose}
      className="z-50"
    >
      <Form form={form} layout="vertical">
        <canvas id="idcanvas" className="hidden"></canvas>
        {/* <img id="cat"  width="100" height="80" src="https://svomdev.adsun.vn/OrderImages/20240724/240724004/f70f2f7f-627d-49a5-a332-6bc9724bc97a.png" alt="The Scream"></img> */}

        <div className="border rounded mx-10 flex items-center flex-col">
          <div className="w-fit ">
            {/* panning={{ disabled: true }} */}
            <TransformWrapper wheel={{ smoothStep: 0.003 }}>
              {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <>
                  <Controls />
                  <TransformComponent>
                    <img
                      ref={imageRef}
                      id="view-one-image"
                      className="h-[500px] px-10"
                      src={props.base64 || props.images1.url}
                      style={{ transform: `rotate(${rotation}deg)` }}
                      alt="test"
                    />
                  </TransformComponent>
                </>
              )}
            </TransformWrapper>
          </div>

          <div className="p-2  w-full flex flex-col">
            <div className="flex space-x-2 justify-end mx-10">
              <div className="select-none rounded px-1 hover:bg-gray-500 bg-gray-400">
                <a className="text-white" href={props.base64 || props.images1.url} target="_blank" rel="noreferrer">
                  {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.OpenInNewTab')}
                </a>
              </div>
              <div className="select-none px-1 rounded hover:bg-blue-500 bg-blue-400">
                <button className="text-white" onClick={() => handleDownloadImage('view-one-image')}>
                  {isSaving
                    ? t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Saveing')
                    : t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.SaveToDevice')}
                </button>
              </div>
            </div>
            <Form.Item
              className="px-2"
              // style={{ marginTop: 10 }}
              label={t('Administrator.UploadImage.Comment')}
              name={'comment'}
            >
              <Input
                className="mt-1"
                style={{ width: '100%' }}
                placeholder={t('Input.placeholder')}
                defaultValue={props.images1?.name || ''}
                disabled
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </ModalComponent>
  );
}
